export const handleKeyboardButtonClick = (button, betAmount, setBetAmount) => {
  // eslint-disable-next-line
  const isNumericButton = !isNaN(button);
  const isSpanButton = button.type === 'span';
  if (!betAmount && betAmount !== 0 && button === '.') {
    return;
  }
  if (isNumericButton) {
    setBetAmount(betAmount + button);
  } else if (isSpanButton) {
    setBetAmount(String(betAmount).slice(0, -1));
  } else if (!String(betAmount).includes('.')) {
    setBetAmount(betAmount + button);
  }
};
